import {Injector, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {MessageTranslateService} from '@shared/services';

@Pipe({
  name: 'messageTranslate',
  standalone: false
})
export class MessageTranslatePipe implements PipeTransform, OnDestroy {

  private readonly translate: TranslatePipe;

  constructor (private trService: MessageTranslateService, injector: Injector) {
    const translatePipeInjector = Injector.create({
      providers: [{provide: TranslatePipe, useClass: TranslatePipe}],
      parent: injector
    });
    this.translate = translatePipeInjector.get(TranslatePipe);
  }

  transform(value: any, args?: any): any {
    if (value == null || typeof value === 'string') {
      return this.translate.transform(value, args);
    } else {
      const message = this.trService.transformToUnnestedI18nMessage(value);
      return this.translate.transform(message.messageKey, message.parameters);
    }
  }

  ngOnDestroy(): void {
    this.translate.ngOnDestroy();
  }
}
